var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewchartlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#F6FFFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 18C36.975 18 40 20.975 40 24.725C40 28.425 36.975 31.4375 33.25 31.4375C31.4375 31.4375 29.75 30.7375 28.475 29.475L25 26.4L21.4625 29.5375C20.25 30.75 18.55 31.45 16.75 31.45C13.025 31.45 10 28.425 10 24.725C10 21.025 13.025 18 16.75 18C18.55 18 20.25 18.7 21.525 19.975L25 23.05L28.5375 19.9125C29.75 18.7 31.45 18 33.25 18ZM19.75 27.7125L23.125 24.725L19.8 21.7875C18.95 20.9375 17.8875 20.5 16.75 20.5C14.4125 20.5 12.5 22.3875 12.5 24.725C12.5 27.0625 14.4125 28.95 16.75 28.95C17.8875 28.95 18.95 28.5125 19.75 27.7125ZM30.25 21.7375L26.875 24.725L30.2 27.6625C31.05 28.5125 32.125 28.95 33.25 28.95C35.5875 28.95 37.5 27.0625 37.5 24.725C37.5 22.3875 35.5875 20.5 33.25 20.5C32.1125 20.5 31.05 20.9375 30.25 21.7375Z",
    fill: "#478767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewchartlist);
export default __webpack_public_path__ + "static/media/newchartlist.21908bd7ced7dda2f16e634c6c91d42c.svg";
export { ForwardRef as ReactComponent };